import { ArrowUpRight } from 'lucide-react'
import { useModal } from '../contexts/ModalContext'
import FormularioRD from '../rdstation/formularioRD'

export default function BadgetOtimize() {
  const { openModal } = useModal()

  return (
    <div className="relative ps-[2px] py-[2px] pe-px rounded-[10px] bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] w-full">
      <div className="flex items-center justify-between gap-8 bg-[#2B283D] px-6 py-3.5 rounded-[10px] text-white w-full">
        <h3 className="w-fit font-inter-light text-sm">Otimize seu negócio!</h3>
        <button
          type="button"
          onClick={() => openModal(<FormularioRD />)}
          className="w-fit bg-white text-black text-xs font-inter-light flex items-center gap-2 py-2 px-6 rounded-full cursor-pointer hover:scale-105 transition-all duration-300"
        >
          Contratar <ArrowUpRight className="size-3" />
        </button>
      </div>
    </div>
  )
}
